export default function initialize_slides_from_dataset(container) {
	const
		wrapper = container.querySelector('.swiper-wrapper'),
		approved_photos = JSON.parse(wrapper.dataset.approvedPhotos);

	while (wrapper.firstChild) wrapper.removeChild(wrapper.lastChild);

	approved_photos.forEach(approved_photo => {
		const slide = document.createElement('div');
		slide.classList.add('swiper-slide');
		slide.style.backgroundImage = `url(${approved_photo})`;
		wrapper.appendChild(slide);
	});
}
